import { BRANCH } from "../../components/constants";
import { CLOSE_LOADER, OPEN_LOADER } from "../actions/appActions";
import {
  BRANCH_CLASSGROUP_LEVEL_CLASSROOMS,
  BRANCH_CLASS_GROUP_STRUCTURE,
  BRANCH_HIERARCHY,
  BRANCH_LEVEL_CLASSGROUPS,
  BRANCH_STRUCTURE,
  FEE_STRUCTURE,
  RESET_BRANCH_CLASSGROUP_LEVEL_CLASSROOMS,
  RESET_BRANCH_LEVEL_CLASSGROUPS,
  SET_BRANCH_LIST,
  SET_CLASS_ROOMS,
  SET_FEES,
} from "../actions/feesActions";

const initialState = {
  feeDetails: [],
  loader: false,
  branchList: [],
  feeStructure: {},
  branchLevelDetails: [],
  statesList: [],
  branchClassGroupLevelDetails: [],
  classRoomsList: [],
  branchLevelClassGroups: [],
  branchClassGroupLevelClassRooms: [],
  branchHierarchyData:[]
};

export const feesReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case CLOSE_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_FEES:
      return {
        ...state,
        feeDetails: action.payload,
      };
    case SET_BRANCH_LIST:
      return {
        ...state,
        branchList: action.payload,
      };
    case FEE_STRUCTURE:
      return {
        ...state,
        feeStructure: action.payload,
      };
    case BRANCH_STRUCTURE:
      return {
        ...state,
        branchLevelDetails: action.payload,
      };
    case BRANCH_CLASS_GROUP_STRUCTURE:
      return {
        ...state,
        branchClassGroupLevelDetails: action.payload,
      };
    case SET_CLASS_ROOMS:
      return {
        ...state,
        classRoomsList: action.payload,
      };
    case BRANCH_LEVEL_CLASSGROUPS:
      return {
        ...state,
        branchLevelClassGroups: action.payload,
      };
    case BRANCH_CLASSGROUP_LEVEL_CLASSROOMS:
      return {
        ...state,
        branchClassGroupLevelClassRooms: action.payload,
      };
    case RESET_BRANCH_LEVEL_CLASSGROUPS:
      return {
        ...state,
        branchLevelClassGroups: action.payload,
      };
    case RESET_BRANCH_CLASSGROUP_LEVEL_CLASSROOMS:
      return {
        ...state,
        branchClassGroupLevelClassRooms: action.payload,
      };
      case BRANCH_HIERARCHY:
        return {
          ...state,
          branchHierarchyData: action.payload,
        };

    default:
      return state;
  }
};
